import { useEffect, useState } from "react";
import { Search, MessageCircle, Reply, Handshake, PoundSterling, ChevronRight } from "lucide-react";
import { api } from "@/lib/api";

export const TrufflPipeline = ({ refreshKey = 0 }) => {
  const [p, setP] = useState(null);

  useEffect(() => {
    api.get("/truffl/pipeline").then(({ data }) => setP(data)).catch(() => {});
  }, [refreshKey]);

  if (!p) return null;

  const stages = [
    { icon: Search, label: "Found", value: p.stages.found, sub: "Leads discovered" },
    { icon: MessageCircle, label: "Contacted", value: p.stages.contacted, sub: "First contact sent" },
    { icon: Reply, label: "Response", value: p.stages.responded, sub: "In conversation" },
    { icon: Handshake, label: "Customer", value: p.stages.customers, sub: "Clients won" },
    { icon: PoundSterling, label: "Paid", value: p.stages.paid, sub: p.won_amount > 0 ? `£${p.won_amount} verified` : "Revenue logged" },
  ];

  return (
    <div className="mt-4 rounded-2xl border border-border bg-card p-5" data-testid="truffl-pipeline">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-medium">Your customer journey — one connected pipeline</p>
        <span className="text-xs text-muted-foreground">{p.stages.found} leads</span>
      </div>
      <div className="mt-3 flex items-stretch gap-1 overflow-x-auto pb-1">
        {stages.map((s, i) => (
          <div key={s.label} className="flex items-center">
            <div data-testid={`truffl-stage-${s.label.toLowerCase()}`}
              className={`flex min-w-[92px] flex-col items-center rounded-xl border px-2.5 py-2.5 text-center ${s.value > 0 ? "border-primary/40 bg-primary/5" : "border-border bg-background"}`}>
              <s.icon className={`h-4 w-4 ${s.value > 0 ? "text-primary" : "text-muted-foreground"}`} />
              <span className="mt-1 text-lg font-semibold leading-none">{s.value}</span>
              <span className="mt-0.5 text-[11px] font-medium">{s.label}</span>
              <span className="max-w-[88px] truncate text-[10px] text-muted-foreground">{s.sub}</span>
            </div>
            {i < stages.length - 1 ? <ChevronRight className="mx-0.5 h-4 w-4 shrink-0 text-muted-foreground/50" /> : null}
          </div>
        ))}
      </div>
      <p className="mt-3 rounded-xl bg-background px-3 py-2 text-xs text-muted-foreground" data-testid="truffl-pipeline-hint">
        ➡️ {p.next_hint}
      </p>
    </div>
  );
};
